import { openBiDirectionalChannel } from './utils';
import { GET_CONTEXT } from './constants';
var context = {
  get: params => {
    openBiDirectionalChannel(params, {
      type: GET_CONTEXT
    });
  }
};
export default context;